(function () {
  var COUNTER_API_URL = "https://point-charge.oryzae.workers.dev/api/stats/granola-servings";
  var COUNTER_STORAGE_KEY = "glp_last_servings_260617";
  var ROOT_SELECTOR = "[data-lp-template='lp-granola-set-otp-common-260617']";
  var DISCOUNT_PATH = "/discount/regular-granola-set-freeship";
  var CHECKOUT_PATH = DISCOUNT_PATH + "?redirect=/checkout";
  var FALLBACK_PRODUCT_PATH = DISCOUNT_PATH + "?redirect=/products/granola-regular";

  if (window.__glp260617 && window.__glp260617.destroy) {
    window.__glp260617.destroy();
  }

  var rootStates = new WeakMap();
  var activeRoots = [];
  var globalListeners = [];

  function on(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    globalListeners.push(function () {
      target.removeEventListener(eventName, handler, options);
    });
  }

  function emitLpEvent(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  function findRoots(scope) {
    if (!scope) return Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));
    if (scope.matches && scope.matches(ROOT_SELECTOR)) return [scope];
    return Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll(ROOT_SELECTOR) : []);
  }

  function clearState(state) {
    if (!state) return;
    state.timeouts.forEach(function (id) { window.clearTimeout(id); });
    state.rafs.forEach(function (id) { window.cancelAnimationFrame(id); });
    if (state.intervals) state.intervals.forEach(function (id) { window.clearInterval(id); });
    if (state.abortController) state.abortController.abort();
    if (state.purchaseCtaCleanups) state.purchaseCtaCleanups.forEach(function (cleanup) { cleanup(); });
    state.timeouts = [];
    state.rafs = [];
    state.intervals = [];
    state.abortController = null;
    state.purchaseCtaCleanups = [];
  }

  function destroyRoot(root) {
    var state = rootStates.get(root);
    clearState(state);
    rootStates.delete(root);
    activeRoots = activeRoots.filter(function (item) { return item !== root; });
  }

  function destroyAll() {
    activeRoots.slice().forEach(destroyRoot);
    globalListeners.forEach(function (remove) { remove(); });
    globalListeners = [];
  }

  function scheduleTimeout(state, callback, delay) {
    var id = window.setTimeout(function () {
      state.timeouts = state.timeouts.filter(function (item) { return item !== id; });
      callback();
    }, delay);
    state.timeouts.push(id);
    return id;
  }

  function scheduleRaf(state, callback) {
    var id = window.requestAnimationFrame(function (timestamp) {
      state.rafs = state.rafs.filter(function (item) { return item !== id; });
      callback(timestamp);
    });
    state.rafs.push(id);
    return id;
  }

  function formatCounterValue(value) {
    var number = Math.max(0, parseInt(value, 10) || 0);
    var chars = number.toLocaleString("ja-JP").split("");
    return chars.map(function (char) {
      if (char === ",") return '<span class="glp-counter__comma">,</span>';
      return '<span class="glp-counter__digit">' + char + "</span>";
    }).join("") + '<span class="glp-counter__unit">\u98df</span>';
  }

  function setCounterValue(counter, value, animate, state) {
    var valueEl = counter.querySelector("[data-lp-counter-value]");
    if (!valueEl) return;
    valueEl.innerHTML = formatCounterValue(value);
    if (!animate) return;

    Array.prototype.forEach.call(valueEl.querySelectorAll(".glp-counter__digit"), function (digit, index) {
      scheduleTimeout(state, function () {
        if (!document.documentElement.contains(digit)) return;
        digit.classList.add("is-flipping");
        scheduleTimeout(state, function () {
          if (document.documentElement.contains(digit)) digit.classList.remove("is-flipping");
        }, 480);
      }, index * 28);
    });
  }

  function addCounterFeed(counter, previousValue, nextValue, allowLargeDiff) {
    var feed = counter.querySelector("[data-lp-counter-feed]");
    if (!feed || !previousValue || nextValue <= previousValue) return;
    var diff = nextValue - previousValue;
    if (!allowLargeDiff && diff > 5000) return;
    feed.innerHTML = `<div>\u305f\u3063\u305f\u4eca <strong>+${diff.toLocaleString("ja-JP")}\u98df</strong></div>`;
  }

  function clearCounterFeed(counter) {
    var feed = counter.querySelector("[data-lp-counter-feed]");
    if (feed) feed.innerHTML = "";
  }

  function getInitialCounterValue(counter) {
    var fallback = parseInt(counter.getAttribute("data-fallback-value"), 10) || 4049469;
    try {
      var saved = parseInt(localStorage.getItem(COUNTER_STORAGE_KEY), 10);
      if (!isNaN(saved) && saved > fallback) {
        return { fallback: fallback, initial: saved, source: "storage" };
      }
    } catch (error) {}
    return { fallback: fallback, initial: fallback, source: "fallback" };
  }

  function animateCounterFromZero(counter, target, state) {
    scheduleRaf(state, function () {
      var start = 0;
      var duration = 1200;
      var startedAt = null;

      function tick(timestamp) {
        if (!document.documentElement.contains(counter)) return;
        if (startedAt === null) startedAt = timestamp;
        var progress = Math.min((timestamp - startedAt) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        setCounterValue(counter, Math.floor(start + (target - start) * eased), false, state);
        if (progress < 1) {
          scheduleRaf(state, tick);
        } else {
          setCounterValue(counter, target, true, state);
        }
      }

      scheduleRaf(state, tick);
    });
  }

  function startCounterPlaceholder(counter, fallback, state) {
    var lower = Math.max(4000000, fallback - 25000);
    var upper = Math.max(lower + 1, fallback + 25000);

    function draw() {
      if (!document.documentElement.contains(counter)) return;
      var value = lower + Math.floor(Math.random() * (upper - lower));
      setCounterValue(counter, value, false, state);
    }

    draw();
    var id = window.setInterval(draw, 90);
    state.intervals.push(id);
    return id;
  }

  function stopCounterPlaceholder(state, intervalId) {
    if (!intervalId) return;
    window.clearInterval(intervalId);
    state.intervals = state.intervals.filter(function (id) { return id !== intervalId; });
  }

  function initCounter(root, state) {
    var counter = root.querySelector("[data-lp-counter]");
    if (!counter) return;

    var values = getInitialCounterValue(counter);
    var initial = values.initial;
    var fallback = values.fallback;
    var hasStoredValue = values.source === "storage";
    var placeholderInterval = null;

    clearCounterFeed(counter);
    if (hasStoredValue) {
      setCounterValue(counter, initial, false, state);
      animateCounterFromZero(counter, initial, state);
    } else {
      counter.classList.add("is-counter-loading");
      placeholderInterval = startCounterPlaceholder(counter, fallback, state);
    }

    scheduleTimeout(state, function () {
      state.abortController = new AbortController();
      scheduleTimeout(state, function () {
        if (!document.documentElement.contains(counter) || !counter.classList.contains("is-counter-loading")) return;
        stopCounterPlaceholder(state, placeholderInterval);
        counter.classList.remove("is-counter-loading");
        setCounterValue(counter, fallback, false, state);
      }, 5000);
      fetch(COUNTER_API_URL, { cache: "no-store", signal: state.abortController.signal })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          if (!document.documentElement.contains(counter)) return;
          var apiValue = data && data.success && typeof data.servings === "number" ? data.servings : 0;
          if (!apiValue) {
            stopCounterPlaceholder(state, placeholderInterval);
            counter.classList.remove("is-counter-loading");
            setCounterValue(counter, fallback, false, state);
            return;
          }
          stopCounterPlaceholder(state, placeholderInterval);
          counter.classList.remove("is-counter-loading");
          addCounterFeed(counter, hasStoredValue ? initial : 0, apiValue, false);
          setCounterValue(counter, apiValue, true, state);
          try { localStorage.setItem(COUNTER_STORAGE_KEY, String(apiValue)); } catch (error) {}
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") return;
          if (document.documentElement.contains(counter)) {
            stopCounterPlaceholder(state, placeholderInterval);
            counter.classList.remove("is-counter-loading");
            setCounterValue(counter, fallback, false, state);
          }
        });
    }, 0);
  }

  function updateStickyCta(root) {
    var cta = root.querySelector("[data-lp-sticky-cta]");
    if (!cta) return;
    var showAfter = parseInt(cta.getAttribute("data-show-after"), 10) || 420;
    var shouldShow = window.scrollY > Math.max(showAfter, window.innerHeight * 0.45);
    cta.classList.toggle("is-visible", shouldShow);
  }

  function updateAllStickyCtas() {
    activeRoots.forEach(updateStickyCta);
  }

  function requestCart(path, options) {
    return fetch(path, options).then(function (response) {
      if (!response.ok) throw new Error("Cart API request failed: " + response.status);
      return response;
    });
  }

  function initPurchaseCtas(root, state) {
    Array.prototype.forEach.call(root.querySelectorAll("[data-variant]"), function (cta) {
      var variantId = (cta.getAttribute("data-variant") || "").trim();
      if (!/^\d+$/.test(variantId)) return;

      function handlePurchaseClick(event) {
        if (window.Shopify && window.Shopify.designMode) {
          event.preventDefault();
          console.info("[Granola LP] CTA processing skipped in Shopify design mode.");
          return;
        }

        event.preventDefault();
        if (cta.getAttribute("aria-busy") === "true") return;
        cta.setAttribute("aria-busy", "true");

        var purchaseWindow = window.open("about:blank", "_blank");
        if (purchaseWindow) purchaseWindow.opener = null;

        function navigatePurchase(path) {
          if (purchaseWindow && !purchaseWindow.closed) {
            purchaseWindow.location.replace(path);
            return;
          }
          window.location.assign(path);
        }

        requestCart("/cart/clear.js", {
          method: "POST",
          headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
        })
          .then(function () {
            return requestCart("/cart/add.js", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
              },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
            });
          })
          .then(function () {
            navigatePurchase(CHECKOUT_PATH);
          })
          .catch(function () {
            navigatePurchase(FALLBACK_PRODUCT_PATH);
          });
      }

      cta.addEventListener("click", handlePurchaseClick);
      state.purchaseCtaCleanups.push(function () {
        cta.removeEventListener("click", handlePurchaseClick);
      });
    });
  }

  function initRoot(root) {
    if (!root || rootStates.has(root)) return;
    var state = { timeouts: [], rafs: [], intervals: [], abortController: null, purchaseCtaCleanups: [] };
    rootStates.set(root, state);
    activeRoots.push(root);
    initCounter(root, state);
    initPurchaseCtas(root, state);
    updateStickyCta(root);
  }

  function initScope(scope) {
    findRoots(scope).forEach(initRoot);
  }

  function handleDocumentClick(event) {
    var target = event.target.closest("[data-lp-click]");
    if (!target || !target.closest(ROOT_SELECTOR)) return;

    emitLpEvent("lp_granola_set_click", {
      lp_action: target.getAttribute("data-lp-click"),
      product_title: target.getAttribute("data-product-title") || "",
      variant_id: target.getAttribute("data-variant-id") || "",
      link_url: target.getAttribute("href") || target.getAttribute("data-lp-copy-url") || ""
    });

    var closeButton = target.closest("[data-lp-story-close]");
    if (closeButton) {
      var storyDetails = closeButton.closest(".glp-story-accordion__details");
      if (storyDetails) {
        storyDetails.open = false;
        var summary = storyDetails.querySelector(".glp-story-accordion__summary");
        if (summary && summary.scrollIntoView) summary.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    var copyButton = target.closest("[data-lp-copy-url]");
    if (!copyButton) return;
    var url = copyButton.getAttribute("data-lp-copy-url") || window.location.href;
    if (!navigator.clipboard) return;

    navigator.clipboard.writeText(url).then(function () {
      var original = copyButton.textContent;
      copyButton.textContent = "コピー済み";
      window.setTimeout(function () {
        if (document.documentElement.contains(copyButton)) copyButton.textContent = original || "URL";
      }, 1500);
    });
  }

  function handleSubmit(event) {
    var form = event.target.closest("[data-lp-product-form]");
    if (!form || !form.closest(ROOT_SELECTOR)) return;

    emitLpEvent("lp_granola_set_product_submit", {
      product_title: form.getAttribute("data-lp-product-title") || "",
      variant_id: (form.querySelector('input[name="id"]') || {}).value || ""
    });

    window.setTimeout(function () {
      window.location.href = "/checkout";
    }, 120);
  }

  function handleSectionLoad(event) {
    initScope(event.target);
  }

  function handleSectionUnload(event) {
    findRoots(event.target).forEach(destroyRoot);
  }

  function handleBlockSelect(event) {
    var root = event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (root) updateStickyCta(root);
  }

  on(document, "click", handleDocumentClick);
  on(document, "submit", handleSubmit);
  on(window, "scroll", updateAllStickyCtas, { passive: true });
  on(window, "resize", updateAllStickyCtas);
  on(document, "shopify:section:load", handleSectionLoad);
  on(document, "shopify:section:unload", handleSectionUnload);
  on(document, "shopify:block:select", handleBlockSelect);
  on(document, "shopify:block:deselect", handleBlockSelect);
  on(document, "DOMContentLoaded", function () { initScope(document); });

  initScope(document);

  window.__glp260617 = {
    init: initScope,
    destroy: destroyAll
  };
})();
